import React from 'react'
import { LeftPanel, RightPanel } from './Panels'
import '../../../assets/stylesheets/auth.css'

/**
 * Authentication Container component
 *
 * Main orchestrator for the authentication UI that combines left and right panels.
 * Handles responsive layout and provides the components configuration for the
 * Clerk sign-in & sign-up forms.
 */
const AuthContainer = () => {

  return (
    <div className="auth-wrapper">
      <div className="auth-form-container">
        <LeftPanel />
        <div className="right-auth-panel">
          <RightPanel />
        </div>
      </div>
    </div>
  )
}

export default AuthContainer
